import React from "react";

import styles from "./ContentBody.module.css";

function ContentBody(props) {
  const cls = props.noTopPadding
    ? `${styles.Wrap} ${styles.NoTop}`
    : styles.Wrap;

  return <div className={cls}>{props.children}</div>;
}

export default ContentBody;
